import * as React from "react";
import * as ReactDOM from "react-dom";
import { dialogContainerElement } from "../../..";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { Buttons } from "../Common/components/Buttons";
import { generateButtons } from "../Common/components/Buttons.utils";
import { Dialog } from "../Common/components/Dialog";
import { DialogContent } from "../Common/components/DialogContent";
import { Title } from "../Common/components/Title";
import { Wrapper } from "../Common/components/Wrapper";
import { IDialogMobile } from "./DialogMobile";

export class DialogMobileDefaultView extends React.PureComponent<
  IDialogMobile
> {
  private ref: React.RefObject<HTMLDivElement> = React.createRef();

  public componentDidUpdate() {
    if (this.ref.current) {
      this.ref.current.focus();
    }
  }

  public render() {
    const {
      message,
      title,
      hideDialog,
      buttons,
      showing,
      cover,
      centerMessage,
      scrollable
    } = this.props;

    if (!showing) {
      return null;
    }

    const hasButtons = buttons && buttons.length > 0;

    return ReactDOM.createPortal(
      <Wrapper ref={this.ref} cover={cover}>
        <Dialog data-e2e-id={E2EIdentifier.DIALOG}>
          <Title data-e2e-id={E2EIdentifier.DIALOG_TITLE}>{title}</Title>
          <DialogContent
            data-e2e-id={E2EIdentifier.DIALOG_MESSAGE}
            message={message}
            centerMessage={centerMessage}
            scrollable={scrollable}
          >
            {message}
          </DialogContent>
          {hasButtons && (
            <Buttons buttonCount={buttons.length}>
              {generateButtons(buttons, hideDialog)}
            </Buttons>
          )}
        </Dialog>
      </Wrapper>,
      dialogContainerElement
    );
  }
}
